import { ref } from 'vue';
import api from '@/utils/axiosConfig';

export function useHttp() {
  const loading = ref(false);
  const error = ref(null);
  const data = ref(null);

  const request = async (method, url, payload = null, options = {}) => {
    //console.log(`[useHttp] Iniciando request: ${method} ${url}`);
    loading.value = true;
    error.value = null;
    data.value = null;
    // console.log(url);
    // console.log("options ", options);
    try {
        //console.log(`[useHttp] Haciendo llamada axios...`);
        //console.log(`[useHttp] URL completa: ${api.defaults.baseURL}${url}`);
        //console.log(`[useHttp] Configuración completa:`, {
        //   method,
        //   url,
        //   baseURL: api.defaults.baseURL,
        //   data: payload,
        //   ...options
        // });
        const response = await api({
            method,
            url,
            data: payload,
            ...options, 
        });
        //console.log(`[useHttp] Respuesta recibida:`, response.data);
        data.value = response.data;
    } 
    catch (err) {
        console.error(`[useHttp] Error en request:`, err);
        error.value = err.response?.data?.message || err.message || 'Something went wrong';
        throw err;
    } 
    finally {
      //console.log(`[useHttp] Finalizando request`);
      loading.value = false;
    }
  };

  const get = (url, options = {}) => request('get', url, null, options);
  const post = (url, payload, options = {}) => request('post', url, payload, options);
  const put = (url, payload, options = {}) => request('put', url, payload, options);
  const patch = (url, payload, options = {}) => request('patch', url, payload, options);
  const del = (url, options = {}) => request('delete', url, null, options);

  return {
    loading,
    error,
    data,
    get,
    post,
    patch,
    del,
    put
  };
}
